<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">获取人的详细信息</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			根据人的ID获取该人的全部信息，json结构的字符串。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code"> public String SKFaceGetPersonInfo(String PersonID);</code></pre>
		<h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">
             <p class="doc_main_p">PersonID：人员ID</p>
        </p>
        <h3 class="doc_main_h3">返回值</h3>
        <pre class="doc_main_pre"><code class="doc_main_code">String类型，人员细节信息，json格式，例如：
{
    "Person_id":"551230",
    "Person_Name":"王某某",
    "Birth":"1994-09-27",
    "Gender":1,
    "Images":[
        {
            "ImageUrl":"http://skfrm.cn/Uploads/57871.jpg",
            "ImageThumbUrl":"http://skfrm.cn/Uploads/257971.jpg"
        }
    ],
    "Groups":[
        {
            "Group_Id":"3910",
            "Group_Path":"注册人员（根目录）/盛开互动/"
        }
    ],
    "Details":""
}

字段含义：
{
    "Person_id": ID,
    "Person_Name": 姓名,
    "Birth":生日,
    "Gender":性别,
    "Images":图像信息
            "ImageUrl":头像地址,
            "ImageThumbUrl":缩略图地址
    "Groups":分组信息
            "Group_Id":组ID,
            "Group_Path":路径
    "Details":细节信息
}</code></pre>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">String personInfo = skFaceSDKLive.SKFaceGetPersonInfo(PersonID);</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Android','视频接口','获取人的详细信息'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	


// WEBPACK FOOTER //
// src/views/documents/skfacesdklive/voideinitiali/VoideGetpeople.vue